// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1sBDa","list":"BalanceDue_list__2eXNl","listRow":"BalanceDue_listRow__4-YAj","total":"BalanceDue_total__3JGY7"};